export default "__VITE_ASSET__DYSyhYgU__"